<template>
<div>
  <p>
      The game has been paused.
  </p>
</div>
</template>

<script>
export default {
  components: {

  },
  props: {
    event: Object
  },
  methods: {

  }
}
</script>

<style scoped>
</style>
